import styles from "../styles/ui/ContentCardTitle.module.css";

function ContentCardTitle({ className = "", style = {}, title = "" }) {
  return (
    <h2 className={`${styles.title} ${className}`} style={style}>
      {title}
    </h2>
  );
}

export default ContentCardTitle;
